//@flow
import React, { Component } from "react";
import type { ProductAttributeType } from "../types/product.js";

type Props = {
  title: string,
  productAttributeList: Array<ProductAttributeType>
};

class ProductDetailsBlock extends Component<Props> {
  render() {
    const title = this.props.title;
    const producyAttributeList = this.props.productAttributeList;
    return (
      <div className="wishlist-tile__specs-block">
        <h5 className="wishlist-tile__specs-heading">{title}</h5>
        <table className="wishlist-tile__specs-table">
          <tbody>
            {producyAttributeList.map(productAttribute => {
              return (
                <tr key={productAttribute.name}>
                  <th scope="row">{productAttribute.name}</th>
                  <td>{productAttribute.value}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    );
  }
}

export default ProductDetailsBlock;
